import StockForecast from '../../model/forecast-stock-data';
import PageHelper from '../../helpers/page-helper';

export default class AvailabilityStatusIcon {

  static readonly ASYNC_KEY = 'availabilityStatusIcon';

  /* eslint-disable max-len */
  private static readonly DELIVERY_DATE_UNKNOWN_ICON = `<img width="18" height="18" src="${window.ACC.config.commonResourcePath}/images/icons/cross-circle-black.svg" alt=""/>`;
  private static readonly PARTIAL_DELIVERY_ICON = `<img width="18" height="18" src="${window.ACC.config.commonResourcePath}/images/icons/alert-round-orange-bold.png" alt=""/>`;
  private static readonly DELIVERY_DATE_KNOWN_ICON = `<img width="18" height="18" src="${window.ACC.config.commonResourcePath}/images/icons/check-circle-green.png" alt=""/>`;
  private static readonly DELIVERY_DATE_EXPECTED_ICON = `<img width="18" height="18" src="${window.ACC.config.commonResourcePath}/images/icons/check-circle-grey.png" alt=""/>`;
  /* eslint-enable max-len */

  constructor(private readonly container: HTMLElement, private stockForecast: StockForecast[] = []) {
    this.render();
  }

  static getIcon(stockForecast: StockForecast[]): string {
    if (!stockForecast) {
      return this.DELIVERY_DATE_UNKNOWN_ICON;
    }

    if (stockForecast[0].unknownForecast) {
      return PageHelper.isInitialOrderPage()
        ? this.DELIVERY_DATE_EXPECTED_ICON
        : this.DELIVERY_DATE_UNKNOWN_ICON;

    }

    const atLeastOneUnknownForecast = stockForecast.some((forecast) => forecast.unknownForecast);
    if (atLeastOneUnknownForecast) {
      return this.PARTIAL_DELIVERY_ICON;
    }

    return this.DELIVERY_DATE_KNOWN_ICON;
  }

  render(): void {
    this.container.innerHTML = AvailabilityStatusIcon.getIcon(this.stockForecast);
  }

  setStockForecast(stockForecast: StockForecast[] = []): void {
    this.stockForecast = stockForecast;
    this.render();
  }
}
